

























import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
import LabelInput from '@/components/molecules/LabelInput.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { isEmptyArray } from '@/utils/CommonUtils';

@Component({
  components: {
    LabelInput,
  },
})
export default class LabelCard extends Vue {
  @Prop()
  private inputtedLabels!: string[];

  @Prop()
  private existingLabels!: string[];

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  @Emit('changedHolidayLabels')
  private changeHolidayLabels(inputtedLabels: string[]): void {}

  @Emit('validationErrorInEventCalendarHolidayLabelCard')
  @Watch('inputtedLabels')
  private doesAnyErrorExists(): boolean {
    const isInvalid = isEmptyArray(this.inputtedLabels);
    return isInvalid;
  }
}
